export default __webpack_public_path__ + "static/media/bitkeep.8f402cf3.svg";